import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { captureInviteToken } from "./lib/inviteAcceptance";
import { applyAppearance, loadAppearance } from "./lib/preferences";
import { setupPwaRegistration } from "./lib/pwa";
import "./styles.css";

// O fragmento contém uma credencial de uso único. Capture e remova antes de
// montar o React para que StrictMode não o leia duas vezes e nenhuma navegação
// subsequente preserve o token na barra de endereço.
const initialInvite = captureInviteToken(window.location, window.history);
applyAppearance(loadAppearance());
setupPwaRegistration();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App initialInvite={initialInvite} />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
